'use client';

import React, { useState } from 'react';

import RichText from '@/components/ui/RichText/RichText';

import { InfoAndAccordionItem } from './types';

interface Props {
  question: InfoAndAccordionItem;
  last?: boolean;
  open?: boolean;
}

const AccordionItemType: React.FC<Props> = ({ question, open = false }) => {
  const [isOpen, setIsOpen] = useState(open);

  return (
    <div className="w-full bg-white p-4">
      <article className="w-full">
        <button
          type="button"
          className="flex w-full cursor-pointer items-center justify-between gap-4 text-left"
          onClick={() => setIsOpen(!isOpen)}
        >
          {question?.question?.content && (
            <RichText
              styles={{
                ...question.question.styles,
              }}
            >
              {question.question.content}
            </RichText>
          )}

          <div className="bg-surface-icon-bg flex aspect-square h-8 w-8 shrink-0 items-center justify-center rounded-full">
            <span
              className={`text-text-muted transition-transform duration-300 ${
                isOpen ? 'rotate-180' : ''
              }`}
            >
              <svg
                width="18"
                height="18"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5 7.5L10 12.5L15 7.5"
                  stroke="currentColor"
                  strokeWidth="1.75"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
        </button>

        <div
          className={`grid overflow-hidden transition-[grid-template-rows] duration-300 ${
            isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
          }`}
        >
          {question?.answer?.content && (
            <div className="min-h-0">
              <RichText
                styles={{
                  p: `text-body leading-relaxed tracking-[-0.48px] text-text-main font-normal ${
                    isOpen ? 'pt-2' : ''
                  }`,
                  li: 'text-text-main font-normal text-body',
                  ul: 'list-disc pl-5',
                }}
              >
                {question.answer.content}
              </RichText>
            </div>
          )}
        </div>
      </article>
    </div>
  );
};

export default AccordionItemType;
